<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj
          <span>Hiánypótlás</span>
        </h1>
      </div>
    </div>

    <section v-if="fill_info == '' && hianypotlas_fields.length > 0">
    	<div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj hiánypótlás</div>
            <h5 v-if="blockTitleShow(['nyelvtudas'])" class="form-block-title" style="margin-top: 0px;">
              Nyelvtudás
            </h5>
            <UploadHandlerHianypotlas name="nyelvtudas" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>

            <h5 v-if="blockTitleShow(['mellekletek'])" class="form-block-title">
              Mellékletek
            </h5>

            <UploadHandlerHianypotlas name="mellekletek" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>

            <h5 v-if="blockTitleShow(['otdk','hazi_tmdk','egyeb_szakmai_tanulmanyi_versenyek','egyeb_kiemelkedo_szakmai_tevekenyseg','egyeb_szakmai_tevekenyseg','megjelent_publikaciok_mtmt_lista_alapjan','reszesult_osztondijban_mtmt'])" class="form-block-title">
              Opcionális
            </h5>
            <UploadHandlerHianypotlas name="otdk" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="hazi_tmdk" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="egyeb_szakmai_tanulmanyi_versenyek" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="egyeb_kiemelkedo_szakmai_tevekenyseg" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="egyeb_szakmai_tevekenyseg" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="megjelent_publikaciok_mtmt_lista_alapjan" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>
            <UploadHandlerHianypotlas name="reszesult_osztondijban_mtmt" :errors="errors" max_uploaded_files="5" v-on:change="(name, value) => { changeValue(name, value); }" :hianypotlas_fields="hianypotlas_fields"/>

            <button v-on:click="save" type="button" name="kuld" class="button">Hiánypótlás beküldése</button>
          </div>
        </div>
    	</div>
    </section>

    <section v-if="fill_info != ''">
    	<div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">SZE oktatói, kutatói utánpótlás és hallgatói kiválóság ösztöndíj hiánypótlás</div>
            <div class="article-text">
              {{ fill_info }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>

<script>
import Vue from 'vue';
import HTMLHeader from '../tpl_header.vue';
import HTMLFooter from '../tpl_footer.vue';
import ProfileMenu from '../tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      fill_info: '',
      errors: [],
      hianypotlas_fields: [],
      form: {
        values: {
        }
      }
    }
  },
  watch: {

  },
  mounted: function() {
  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

  	var _this = this;

    this.$root.ajax('form/utanpotlas_hallgatoi_osztondij_hianypotlas_lekerdezes/' + this.$route.query.id, {
      success: function(response) {
        if (response.error) {
          _this.fill_info = response.error;
        } else {
          if (response.hianypotlas_fields != undefined) {
            response.hianypotlas_fields.map(function(hf) {
              hf.hianypotlas = JSON.parse(hf.hianypotlas);
              Vue.set(_this.form.values, hf.form_field_key, []);
            });
            _this.hianypotlas_fields = response.hianypotlas_fields;
            if (_this.hianypotlas_fields.length == 0)
              _this.fill_info = 'Önnek nincs szüksége hiánypótlásra.';
          }
          _this.fill_info = response.fill_info;
        }
      }
    });
  },

  methods: {
    blockTitleShow: function(fields) {
      var _this = this;
      var show = false;

      fields.map(function(field) {
        _this.hianypotlas_fields.map(function(hf) {
          if (field == hf.form_field_key)
            show = true;
        });
      });

      return show;
    },

    save: function() {
      var _this = this;

      this.errors = [];

      this.hianypotlas_fields.map(function(hf) {
        hf.hianypotlas.map(function(h) {
          if (_this.form.values[hf.form_field_key] == '') {
            _this.errors.push({
              key: hf.form_field_key,
              form_fill_values_id: hf.id,
              array_index: h.array_index,
              msg: 'Töltse fel a hiányzó fájlokat'
            });
          } else {
            _this.form.values[hf.form_field_key].map(function(b) {
              if (b.files.length == 0 && b.form_fill_values_id == hf.id && b.array_index == h.array_index) {
                _this.errors.push({
                  key: hf.form_field_key,
                  form_fill_values_id: b.form_fill_values_id,
                  array_index: b.array_index,
                  msg: 'Töltse fel a hiányzó fájlokat',
                });
              }
            });
          }
        });
      });

      if (this.errors.length > 0) {
        swal('Hiba!', 'Ellenőrizze a mezőket.', 'error');
        return;
      }

      this.$root.ajax('form/utanpotlas_hallgatoi_osztondij_hianypotlas_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          form_id: this.$route.query.id
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            _this.fill_info = 'Köszönjük. A hiánypótlás beküldése megtörtént.';
          }
        }
      });
    },

    changeValue: function(name, value) {
      this.form.values[name] = value;
    },
  }
}
</script>


// WEBPACK FOOTER //
// utanpotlas_hallgatoi_osztondij_hianypotlas.vue?1f0ce6da